module.exports = __webpack_public_path__ + "img/page15_logo.1ef46acc.png";